import React from 'react'
import { WildImage } from '../InTheWild.utils'
import { PostOrPage } from '@tryghost/content-api'

export const leftImageCollection = (posts: Partial<PostOrPage>[]) => (
  <>
    {posts[0] ? (
      <WildImage
        className="col-span-2 col-start-1 row-span-2 row-start-1"
        imgSrc={posts[0].feature_image}
        imgSlug={posts[0].slug}
        size="large"
      />
    ) : null}
    {posts[1] ? (
      <WildImage
        className="col-start-1 row-start-3"
        imgSrc={posts[1].feature_image}
        imgSlug={posts[1].slug}
        size="small"
      />
    ) : null}
    {posts[2] ? (
      <WildImage
        className="col-start-2 row-start-3"
        imgSrc={posts[2].feature_image}
        imgSlug={posts[2].slug}
        size="small"
      />
    ) : null}
  </>
)

export const centerImageCollection = (posts: Partial<PostOrPage>[]) => (
  <>
    {posts[0] ? (
      <WildImage
        className="col-start-1 row-start-4 md:row-start-1 md:col-start-3"
        imgSrc={posts[0].feature_image}
        imgSlug={posts[0].slug}
        size="small"
      />
    ) : null}
    {posts[1] ? (
      <WildImage
        className="col-start-2 row-start-4 md:row-start-1 md:col-start-4"
        imgSrc={posts[1].feature_image}
        imgSlug={posts[1].slug}
        size="small"
      />
    ) : null}
    {posts[2] ? (
      <WildImage
        className="col-span-2 col-start-1 row-span-2 row-start-5 md:row-start-2 md:col-start-3"
        imgSrc={posts[2].feature_image}
        imgSlug={posts[2].slug}
        size="large"
      />
    ) : null}
  </>
)

export const rightImageCollection = (posts: Partial<PostOrPage>[]) => (
  <>
    {posts[0] ? (
      <WildImage
        className="col-span-2 col-start-1 row-span-2 row-start-7 md:row-start-1 md:col-start-5"
        imgSrc={posts[0].feature_image}
        imgSlug={posts[0].slug}
        size="large"
      />
    ) : null}
    {posts[1] ? (
      <WildImage
        className="col-start-1 row-start-9 md:row-start-3 md:col-start-5"
        imgSrc={posts[1].feature_image}
        imgSlug={posts[1].slug}
        size="small"
      />
    ) : null}
    {posts[2] ? (
      <WildImage
        className="col-start-2 row-start-9 md:row-start-3 md:col-start-6"
        imgSrc={posts[2].feature_image}
        imgSlug={posts[2].slug}
        size="small"
      />
    ) : null}
  </>
)
